import { CircularProgress } from '@mui/material';
import React from 'react';
import { SpinnerContainer } from './Styles';

const Spinner = ({ color, size, style, classes }) => {
  return (
    <SpinnerContainer color={color} style={style} className={classes}>
      <CircularProgress size={20 || size} />
    </SpinnerContainer>
  );
};

export default Spinner;
